import { UserProvider } from './context';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import SellingCurrency from './pages/SellingCurrency';
import BuyingCurrency from './pages/BuyingCurrency';
import SidebarTemplate from './shared/SidebarTemplate';
import { Route, Routes, useLocation } from 'react-router-dom';
import Register from './pages/Auth/Register';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import LocalCurrencyBalance from './pages/LocalCurrencyBalance';
import BulkCoins from "./shared/localCurrencyBalance/BulkCoins";
import Safe from './shared/localCurrencyBalance/Safe';
import Notes from './shared/localCurrencyBalance/Notes';
import CoinsInTray from './shared/localCurrencyBalance/CoinsInTray';
import ForeignCurrencyBalance from './pages/ForeignCurrencyBalance';
import Usd from './shared/foreignCurrencyBalance/Usd';
import Gbp from './shared/foreignCurrencyBalance/Gbp';
import Eur from './shared/foreignCurrencyBalance/Eur';
import LocalBalance from './shared/localCurrencyBalance/LocalBalance';
import Settings from './pages/Settings';
import Header from './shared/Header';
import MyProfile from './pages/MyProfile';
import Test from './pages/Test';
import DailyFOSReport from './pages/DailyFOSReport';
import DailyOpeningAndClosing from './pages/DailyOpeningAndClosing';
import ForeignCurrencyPage from './shared/foreignCurrencyBalance/ForeignCurrencyPage.js';
import ShopSelection from './pages/ShopSelection.js';

function App() {

  // Get my Location
  const myPath = useLocation().pathname;
  const width = myPath === '/login' || myPath === '/register' || myPath === '/forgotPassword' ? "w-full" : "w-[calc(100%-16rem)]"

  return (
    <UserProvider>
      <div className="flex">
        <ToastContainer position='top-right' theme="colored" />
        <SidebarTemplate className="w-64" />
        <div className={`p-4 ${width}`}>
        <Header className='w-[calc(100%-16rem)]' />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/selling-currency" element={<SellingCurrency />} />
            <Route path="/buying-currency" element={<BuyingCurrency />} />
            <Route path="/local-currency-balance" element={<LocalCurrencyBalance />} />
            <Route path="/local-currency-balance/:balanceType" element={<LocalBalance />} />
            <Route path="/safe" element={<Safe />} />
            <Route path="/bulk-coins" element={<BulkCoins />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/coins-in-tray" element={<CoinsInTray />} />
            <Route path="/foreign-currency-balance" element={<ForeignCurrencyBalance />} />
            <Route path="/foreignCurrencyPage/:currency/:country" element={<ForeignCurrencyPage />} />
            <Route path="/foreign-currency-balance/usd" element={<Usd />} />
            <Route path="/foreign-currency-balance/gbp" element={<Gbp />} />
            <Route path="/foreign-currency-balance/eur" element={<Eur />} />
            <Route path="/dailyFOSReport" element={<DailyFOSReport />} />
            <Route path="/dailyOpeningAndClosing" element={<DailyOpeningAndClosing />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/myProfile" element={<MyProfile />} />
            <Route path="/test" element={<Test />} />
            <Route path="/shopSelection" element={<ShopSelection />} />
          </Routes>
        </div>
      </div>
    </UserProvider>
  );
}

export default App;
